import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";
import { Routes } from "./Routes";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_PERMISSIONS",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Tillatelser',
    text: 'Tillatelser',
    canShowOnDashboard: false,
    routes: Routes
})
